import "@/assets/styles/_loader.scss";

const LoadingPreloader = () => {
  return (
    <div className="loading-container">
      <div className="loading-spinner">
        <div className="spinner-circle"></div>
      </div>
    </div>
  );
};

export default LoadingPreloader;
